@if (isVisible) {
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <!-- Backdrop (sin cierre por click) -->
    <div @backdrop class="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

        <!-- Panel -->
        <div @panel class="relative bg-white dark:bg-surface-900 rounded-2xl shadow-2xl p-8 max-w-md w-full">
            <!-- Success Icon -->
            <div class="flex justify-center mb-6">
                <div @icon class="relative w-20 h-20 rounded-full bg-green-100 flex items-center justify-center animate-pulse">
                    <svg class="w-12 h-12 text-green-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path @checkmark d="M4 12 L9 17 L20 6" class="checkmark-path" pathLength="100" />
                    </svg>
                </div>
            </div>

            <!-- Content -->
            <div @text class="text-center space-y-2 mb-6">
                <h2 class="text-2xl font-bold text-gray-900 dark:text-gray-100">
                    {{ title }}
                </h2>
                <p class="text-gray-600 dark:text-gray-300">
                    {{ message }}
                </p>
            </div>

            <!-- Progress Bar -->
            <div class="w-full h-1 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                <div class="h-full bg-green-600 transition-all duration-50 ease-linear rounded-full" [style.width.%]="progress"></div>
            </div>

            <!-- Sin botón de cierre manual -->
        </div>
    </div>
}
